// frontend/src/components/onboarding/Step1Username.js
import React, { useState } from 'react';
import { Form, InputGroup, Alert, Spinner } from 'react-bootstrap';
import { Check, X, AlertCircle } from 'react-feather';
import { api } from '../../utils/Api';


const Step1Username = ({ formData, setFormData, loading , originalUsername}) => {
  const [checking, setChecking] = useState(false);
  const [available, setAvailable] = useState(null);
  const [debounceTimer, setDebounceTimer] = useState(null);

  console.log('🎯 [Step1Username] Render - formData:', formData);
  console.log('🎯 [Step1Username] available:', available);

  const checkUsername = async (username) => {
    console.log('🔍 [Step1Username] Verificando username:', username);
    
    
    if (username.length < 3) {
      setAvailable(null);
      return;
    }

    // ✅ Si el username es el mismo que el usuario ya tiene, considerarlo disponible
    if (originalUsername && username === originalUsername) {
      console.log('✅ Username es el mismo que el actual, considerarlo disponible');
      setAvailable(true);
      return;
    }


    setChecking(true);
    try {
      const response = await api.post('/users/check-username', { username });
      console.log('📥 [Step1Username] Respuesta:', response.data);
      setAvailable(response.data.available);
    } catch (error) {
      console.error('❌ [Step1Username] Error:', error);
      setAvailable(false);
    } finally {
      setChecking(false);
    }
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value.toLowerCase().replace(/[^a-z0-9]/g, '');
    console.log('📝 [Step1Username] Nuevo valor:', value);
    setFormData({ ...formData, username: value });

    if (debounceTimer) clearTimeout(debounceTimer);
    setDebounceTimer(setTimeout(() => checkUsername(value), 500));
  };

  return (
    <div>
      <h5 className="mb-3">1. Elige tu nombre de usuario público</h5>
      <p className="text-muted small mb-4">
        Este será tu enlace: <strong>linkeasy.com.ar/{formData.username || 'tu-nombre'}</strong>
      </p>

      <Form.Group className="mb-4">
        <Form.Label>Nombre de usuario</Form.Label>
        <InputGroup>
          <InputGroup.Text>@</InputGroup.Text>
          <Form.Control
            type="text"
            value={formData.username}
            onChange={handleUsernameChange}
            placeholder="ej: juanperez"
            isInvalid={available === false}
            isValid={available === true}
            disabled={loading}
          />
          <InputGroup.Text>
            {checking ? (
              <Spinner animation="border" size="sm" />
            ) : available === true ? (
              <Check size={18} className="text-success" />
            ) : available === false ? (
              <X size={18} className="text-danger" />
            ) : null}
          </InputGroup.Text>
        </InputGroup>
        
        {available === true && (
          <div className="text-success small mt-2">
            <Check size={14} className="me-1" />
            ¡Disponible!
          </div>
        )}
        
        {available === false && (
          <Alert variant="danger" className="mt-3 p-2 small">
            <AlertCircle size={14} className="me-1" />
            Este nombre ya está en uso. Prueba con otro.
          </Alert>
        )}

        <Form.Text className="text-muted">
          Solo letras minúsculas y números, sin espacios
        </Form.Text>
      </Form.Group>

      <div className="bg-light p-3 rounded">
        <small className="text-muted d-block mb-2">
          ℹ️ Tu nombre público actual:
        </small>
        <div className="d-flex align-items-center">
          <div>
            <strong>{formData.displayName}</strong>
            <div className="small text-muted">@{formData.username}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1Username;